import styled from "styled-components";

export const LoginContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
  min-height: 100vh;

  @media only screen and (max-width: 778px) {
    flex-direction: column;
  }
`;

export const LoginLoadingOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(255, 255, 255, 0.9);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
`;

export const LoadingContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
`;

export const PresentationSection = styled.div<{ $backgroundImage: string }>`
  height: 100vh;
  width: calc(100vw - 400px);
  margin: 0;
  padding: 0;
  background-image: url(${(props) => props.$backgroundImage});
  background-position-x: 50%;
  background-size: cover;
  background-repeat: no-repeat;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;

  @media only screen and (max-width: 778px) {
    width: 100vw;
  }
`;

export const LogoLatam = styled.img`
  width: 200px;
  bottom: 20vh;
  position: absolute;
  z-index: 99;
`;

export const LoginFormContainer = styled.div`
  width: 400px;
  background: transparent;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: -2px 0 10px rgba(0, 0, 0, 0.2);
  position: relative;
  z-index: 10;
  border-top-left-radius: 30px;
  border-bottom-left-radius: 30px;

  @media only screen and (max-width: 778px) {
    width: 100vw;
    position: absolute;
    top: 0;
    left: 0;
    background: rgba(255, 255, 255, 0.95);
    backdrop-filter: blur(10px);
    min-height: auto;
    padding: 1rem;
  }
`;

export const LoginCard = styled.div`
  width: 100%;
  max-width: 350px;
  border: none;
  box-shadow: none;
  background: transparent;

  @media only screen and (max-width: 778px) {
    background: rgba(255, 255, 255, 0.9);
    border-radius: 16px;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
    backdrop-filter: blur(10px);
  }
`;

export const CardContent = styled.div`
  padding: ${({ theme }) => theme.tokens.padding.xl}px;
`;

export const FormHeader = styled.div`
  text-align: center;
  margin-bottom: ${({ theme }) => theme.tokens.size.lg}px;
`;

export const LogoLatamLogin = styled.img`
  width: 125px;
  margin-bottom: ${({ theme }) => theme.tokens.size.sm}px;
`;

export const ButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.tokens.size.sm}px;
`;

export const FormFooter = styled.div`
  margin-top: ${({ theme }) => theme.tokens.size.lg}px;
`;

export const ErrorContainer = styled.div`
  padding: ${({ theme }) => theme.tokens.size.sm}px;
  background-color: ${({ theme }) => theme.tokens.color.surface.errorSoft};
  border: 1px solid ${({ theme }) => theme.tokens.color.border.primary};
  border-radius: ${({ theme }) => theme.tokens.size.sm}px;
  margin-bottom: ${({ theme }) => theme.tokens.size.lg}px;
`;

export const BackToHomeButtonWrapper = styled.div`
  width: 100%;
  margin-top: 1rem;

  & > button {
    width: 100%;
  }
`;